<template>
  <div
    class="grid lg:grid-cols-2 relative lg:h-screen pb-8 lg:pb-0 tracking-wider"
  >
    <div class="px-4 lg:pb-0 lg:h-full lg:overflow-auto">
      <div
        class="py-8 px-4 space-y-4 border-b border-black"
        v-html="press.text"
      ></div>
      <div
        class="py-8 px-4 space-y-4"
        v-if="press.files && press.files.length > 0"
      >
        <a
          v-for="file in press.files"
          :key="file.filename"
          :href="file.url"
          target="_blank"
          class="block"
        >
          <span v-if="file.caption.length > 0">{{ file.caption }}</span>
          <span v-else>{{ file.filename }}</span>
        </a>
      </div>
    </div>
    <div class="hidden lg:block py-4 absolute top-0 left-1/2 w-px h-full">
      <div class="w-full h-full bg-black"></div>
    </div>
    <partners class="hidden lg:block" />
  </div>
</template>

<script>
const Partners = () =>
  import(/* webpackChunkName: "Partners" */ "@/components/Partners.vue");
export default {
  components: {
    Partners,
  },
  created() {
    if (!this.$store.state.press.title) this.$store.dispatch("loadPress");
  },
  computed: {
    press() {
      return this.$store.state.press;
    },
  },
};
</script>
